module.exports = __webpack_public_path__ + "443234654814eb35dbaea43f29193839.svg";